import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { selectJobOverviewData } from '@/store/selectors'
import { RootState } from '@/store/store'

export const Route = createFileRoute('/job/$jobId/$date/signoff')({
  component: JobSignOffLayout,
})

function JobSignOffLayout() {
  const { jobId, date } = Route.useParams()

  const { job, booking } = useSelector((state: RootState) =>
    selectJobOverviewData(state, jobId)
  )

  const client = useSelector((state: RootState) =>
    state.clients.items.find(client => job && client.id === job.company_id)
  )

  if (!job || !booking) {
    return <div>Job not found</div>
  }

  return (
    <>

          {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-100 h-20 flex items-center justify-between p-4 bg-white border-b">
        <div className="flex-1">
          {client?.filename ? (
            <img
              src={`/logos/${client.filename}`}
              alt={client.name}
              className="h-10 w-auto object-contain"
              onError={(e) => {
                console.log('Logo load error:', e)
              }}
            />
          ) : (
            <h1 className="text-2xl font-bold text-gray-900 m-0">
              {client?.name}
            </h1>
          )}
        </div>
        <Link to="/job/$jobId/$date" params={{ jobId, date }}>
          <Button variant="secondary">
            Close
          </Button>
        </Link>
      </div>



    <div className="flex flex-col bg-white col-span-3">
      {/* Content - with top padding to account for fixed header */}
      <div className="flex-1 h-full">
        <Outlet />
      </div>
    </div>
    </>
  )
}
